// @ts-nocheck
import { http } from "@/lib/http";

/** @typedef {{ [key: string]: unknown }} JsonMap */

export function fetchPosts() {
  return http.get("/api/feeds/get_all").then((res) => res.data);
}

/** @param {string} id */
export function fetchPost(id) {
  return http.get(`/api/feeds/get-post/${id}`).then((res) => res.data);
}

/** @param {string} id
 *  @param {JsonMap} payload
 */
export function editPost(id, payload) {
  return http
    .post(`/api/feeds/edit-post`, { docId: id, ...payload })
    .then((res) => res.data);
}

/** @param {string} id */
export function deletePost(id) {
  return http.delete(`/api/feeds/delete/${id}`).then((res) => res.data);
}

/**
 * @param {string} docId
 * @param {boolean} recommended
 */
export function setPostRecommended(docId, recommended) {
  return http
    .post("/api/feeds/edit-recommended", { docId, data: { recommended } })
    .then((res) => res.data);
}

/** @param {JsonMap} postData */
export function createPost(postData) {
  return http.post("/api/feeds/create-post", postData).then((res) => res.data);
}

/** @param {string} input */
export function searchPlaces(input) {
  return http
    .post("/api/feeds/getPlaces", { input })
    .then((res) => res.data?.data || []);
}

/**
 * @param {{ duration: string, post_start_date: string, post_end_date: string }} params
 */
export function exportPostsUrl({ duration, post_start_date, post_end_date }) {
  const base = import.meta.env.VITE_API_BASE_URL || "";
  return `${base}/api/feeds/exportData?${new URLSearchParams({
    duration,
    post_start_date,
    post_end_date,
  }).toString()}`;
}
